import { createContext } from 'react';

type ToastType = 'success' | 'error' | 'info';

interface Toast {
  id: string;
  type: ToastType;
  message: string;
}

export interface ToastContextValue {
  toasts: Toast[];
  addToast: (type: ToastType, message: string) => void;
  removeToast: (id: string) => void;
}

/**
 * APP-W01d: toast entries carry the identity generation they were captured
 * under. A generation transition clears every toast captured before it, so
 * identity A's pending notification can never surface in identity B. The
 * generation field is internal bookkeeping — public consumers of
 * ToastContextValue keep their exact prior shape.
 */
export interface ToastWithGeneration extends Toast {
  /** Identity generation captured when the toast was added. */
  generation: number | null;
}

export const ToastContext = createContext<ToastContextValue | null>(null);
